'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError(err, definedAt) {
  this.Yv = null;
  this.aYl = null;
  this.Yv = err;
  this.aYl = definedAt;
}
export { $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError as $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError };
$p = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError() {
}
export { $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError as $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError };
$h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError)) {
    var x = this.Yv;
    var x$2 = x$0.Yv;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "OnNetworkError";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yv;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.VM = (function() {
  return this.aYl;
});
function $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kD)));
}
export { $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError as $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError };
var $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError, "app.webclient_prelude.components.AppMainModal$OnNetworkError", ({
  kD: 1,
  d9: 1,
  cU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError as $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnNetworkError };
//# sourceMappingURL=app.webclient_prelude.components.-App-Main-Modal$-On-Network-Error.js.map
